export default {
  editor: null,
  blankPageURL: null,
  macros: {}
};